// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- WRAPPER ---------------- */
.identity-form-wrapper {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  /* align with layout */
}

/* ---------------- CARD ---------------- */
.aptsi-card {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* ---------------- FORM ---------------- */
.form-control {
  height: 42px;
  border-radius: 4px;
}

.form-control:focus {
  box-shadow: none;
  border: 1px solid #0060d6;
}

/* ---------------- LABEL ---------------- */
label {
  font-weight: 500;
  margin-bottom: 5px;
}

/* ---------------- HEADER ---------------- */
h2 {
  margin-bottom: 20px;
  font-weight: 600;
}

/* ---------------- BUTTONS ---------------- */
.action-buttons {
  margin-top: 15px;
}

.btn-submit {
  background-color: #0060d6;
  color: #fff;
  margin-right: 10px;
}
.btn-submit:hover {
  background-color: #1a1a86;
}
.btn-submit:disabled {
  background-color: #9aa7b3;
}

.upload-box {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 25px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background: #fafafa;
}

.upload-box:hover {
  border-color: #0060d6;
  background: #f5f9ff;
}

.upload-box.dragging {
  border-color: #0060d6;
  background: #eaf3ff;
}

.upload-box i {
  font-size: 32px;
  color: #0060d6;
  margin-bottom: 10px;
}

.upload-box p {
  margin: 0;
  font-size: 14px;
  color: #555;
}

.upload-box .browse {
  color: #0060d6;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}

.file-name {
  font-weight: 500;
  color: #1a1a86;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-box {
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/smart-contract-management/smart-contract-management-create-or-update/smart-contract-management-create-or-update.component.scss"],"names":[],"mappings":"AAAA,8CAAA;AAEA;EACE,aAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;AAAF;;AAGA,2CAAA;AAEA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;AADF;;AAIA,2CAAA;AAEA;EACE,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,yBAAA;AAFF;;AAKA,4CAAA;AAEA;EACE,gBAAA;EACA,kBAAA;AAHF;;AAMA,6CAAA;AAEA;EACE,mBAAA;EACA,gBAAA;AAJF;;AAOA,8CAAA;AAEA;EACE,gBAAA;AALF;;AAQA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,yBAAA;AANJ;;AAWA;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AARF;;AAWA;EACE,qBAAA;EACA,mBAAA;AARF;;AAWA;EACE,qBAAA;EACA,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,SAAA;EACA,eAAA;EACA,WAAA;AARF;;AAWA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AARF;;AAWA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AARF","sourcesContent":["/* ---------------- WRAPPER ---------------- */\n\n.identity-form-wrapper {\n  padding: 20px;\n  display: flex;\n  justify-content: flex-start;\n  /* align with layout */\n}\n\n/* ---------------- CARD ---------------- */\n\n.aptsi-card {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 25px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n/* ---------------- FORM ---------------- */\n\n.form-control {\n  height: 42px;\n  border-radius: 4px;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border: 1px solid #0060d6;\n}\n\n/* ---------------- LABEL ---------------- */\n\nlabel {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n/* ---------------- HEADER ---------------- */\n\nh2 {\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.action-buttons {\n  margin-top: 15px;\n}\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #fff;\n  margin-right: 10px;\n\n  &:hover {\n    background-color: #1a1a86;\n  }\n\n  &:disabled {\n    background-color: #9aa7b3;\n  }\n}\n\n\n.upload-box {\n  border: 2px dashed #cbd5e1;\n  border-radius: 8px;\n  padding: 25px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  background: #fafafa;\n}\n\n.upload-box:hover {\n  border-color: #0060d6;\n  background: #f5f9ff;\n}\n\n.upload-box.dragging {\n  border-color: #0060d6;\n  background: #eaf3ff;\n}\n\n.upload-box i {\n  font-size: 32px;\n  color: #0060d6;\n  margin-bottom: 10px;\n}\n\n.upload-box p {\n  margin: 0;\n  font-size: 14px;\n  color: #555;\n}\n\n.upload-box .browse {\n  color: #0060d6;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.file-name {\n  font-weight: 500;\n  color: #1a1a86;\n}\n\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.loader-box {\n  background: #fff;\n  padding: 20px 30px;\n  border-radius: 10px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
